var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "home"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M2.99994 9.56683L11.9999 2.56683L20.9999 9.56683V20.5668C20.9999 21.0973 20.7892 21.606 20.4142 21.981C20.0391 22.3561 19.5304 22.5668 18.9999 22.5668H4.99994C4.46951 22.5668 3.9608 22.3561 3.58573 21.981C3.21065 21.606 2.99994 21.0973 2.99994 20.5668V9.56683Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M8.99994 21.9999V14.9999H14.9999V21.9999",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "square",
  strokeLinejoin: "round"
}))));
export default SvgIconHome;